import { FtIcon } from './icons.tsx'
import { MicPerm } from '../freeTalkStore.ts'

export function PermissionModal(props: {
  perm: MicPerm
  onAllow: () => void
  onHome: () => void
}) {
  if (props.perm === 'unsupported') {
    return (
      <div className="ft-modalwrap">
        <div className="ft-modal" role="dialog" aria-modal="true">
          <div className="ft-mic-ic warn">
            <FtIcon name="warn" size={30} />
          </div>
          <h3>В этом браузере разговор не работает</h3>
          <p>
            Открой Speakalot в Chrome, Safari, Edge или Яндекс Браузере
            последней версии.
          </p>
          <div className="ft-mactions">
            <button className="ft-btn pri" onClick={props.onHome}>
              На главную
            </button>
          </div>
        </div>
      </div>
    )
  }
  if (props.perm === 'denied') {
    return (
      <div className="ft-modalwrap">
        <div className="ft-modal" role="dialog" aria-modal="true">
          <div className="ft-mic-ic warn">
            <FtIcon name="warn" size={30} />
          </div>
          <h3>Доступ к микрофону не получен</h3>
          <p>
            Включи его в настройках браузера: значок замка слева от адреса сайта
            → «Микрофон» → «Разрешить». Потом обнови страницу.
          </p>
          <div className="ft-mactions">
            <button className="ft-btn pri" onClick={props.onAllow}>
              <FtIcon name="mic" size={20} />
              Попробовать ещё раз
            </button>
            <button className="ft-btn sec" onClick={props.onHome}>
              На главную
            </button>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div className="ft-modalwrap">
      <div className="ft-modal" role="dialog" aria-modal="true">
        <div className="ft-mic-ic">
          <FtIcon name="mic" size={30} />
        </div>
        <h3>Нужен микрофон, чтобы ИИ тебя слышал</h3>
        <p>
          Нажимаешь на микрофон — говоришь — нажимаешь ещё раз. Ошибаться можно,
          разбор будет в конце.
        </p>
        <p className="ft-small">
          Мы записываем голос, чтобы распознать речь и разобрать ошибки.
        </p>
        <div className="ft-mactions">
          <button className="ft-btn pri" onClick={props.onAllow} autoFocus>
            <FtIcon name="mic" size={20} />
            Разрешить микрофон
          </button>
          <button className="ft-btn sec" onClick={props.onHome}>
            Не сейчас
          </button>
        </div>
      </div>
    </div>
  )
}
